import { REGEX_VALID_DOMAIN, REGEX_VALID_CHARACTERS } from '../constants'
import TextFieldForm, { TextFieldFormProps } from './TextFieldForm'

export default function NameForm(props: TextFieldFormProps) {
  return <TextFieldForm {...props} filter={REGEX_VALID_CHARACTERS} valid={REGEX_VALID_DOMAIN} />
}
